import { getAuthToken } from "@/services/authService"

export interface MarkdownPage {
  slug: string
  title: string
  content: string
  lastModified: string
}

export interface SaveMarkdownRequest {
  slug: string
  title: string
  content: string
}

export const markdownService = {
  async getMarkdownPage(slug: string): Promise<MarkdownPage> {
    
    const response = await fetch(`/api/markdown/${slug}`)
    
    if (!response.ok) {
      console.error(`❌ markdownService: Response not ok`, response.status, response.statusText)
      throw new Error(`Failed to fetch markdown page: ${response.statusText}`)
    }
    
    const data = await response.json()
    
    return data
  },

  async saveMarkdownPage(data: SaveMarkdownRequest): Promise<MarkdownPage> {
    
    const token = getAuthToken()
    if (!token) {
      throw new Error("No authentication token found")
    }

    const response = await fetch(`/api/markdown/${data.slug}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })
    

    if (!response.ok) {
      console.error(`❌ markdownService: Save response not ok`, response.status, response.statusText)
      throw new Error(`Failed to save markdown page: ${response.statusText}`)
    }

    const result = await response.json()
    
    return result
  },
}
